export default {
  films: {
    currYear: '2024',
    updDate: {
      year: '2024',
      month: '1',
      day: '1'
    },
    myFavListEver: [
      {
        title: 'Possession',
        year: 1981,
        emoji: '🇫🇷',
        chinese: '着魔',
        french: 'Possession'
      },
      {
        title: 'Floating Weeds',
        year: 1959,
        emoji: '🇯🇵',
        chinese: '浮草',
        french: ''
      },
      {
        title: 'Yi Yi',
        year: 2000,
        emoji: '',
        chinese: '一一',
        french: 'Yi Yi'
      },
      {
        title: 'Jeanne Dielman',
        year: 1975,
        emoji: '🇧🇪',
        chinese: '让娜·迪尔曼',
        french: 'Jeanne Dielman, 23 Quai du Commerce, 1080 Bruxelles'
      },
    ],
    myFavListCurrYear: [
      // {
      //   title: 'Hana and Alice',
      //   year: 2004,
      //   emoji: '🇯🇵',
      //   chinese: '花与爱丽丝',
      //   french: ''
      // },
    ],
     myFavListIn2023: [
      {
        title: 'Hana and Alice',
        year: 2004,
        emoji: '🇯🇵',
        chinese: '花与爱丽丝',
        french: ''
      },
      {
        title: 'Je Tu Il Elle',
        year: 1974,
        emoji: '🇫🇷',
        chinese: '我你他她',
        french: ''
      },
      {
        title: 'No Bears',
        year: 2022,
        emoji: '🇮🇷',
        chinese: '无熊之境',
        french: ''
      },
      {
        title: 'The Last Picture Show',
        year: 1971,
        emoji: '🇺🇸',
        chinese: '最后一场电影',
        french: ''
      },
      {
        title: 'The Terrorizers',
        year: 1986,
        emoji: '',
        chinese: '恐怖分子',
        french: ''
      },
      {
        title: 'A Brighter Summer Day',
        year: 1991,
        emoji: '',
        chinese: '牯岭街少年杀人事件',
        french: ''
      },
      {
        title: 'Scenes from a Marriage',
        year: 1974,
        emoji: '🇸🇪',
        chinese: '婚姻生活',
        french: ''
      },
    ],
    myFavListIn2022: [
      {
        title: 'Persona',
        year: 1966,
        emoji: '🇸🇪',
        chinese: '假面',
        french: ''
      },
      {
        title: 'Paris, Texas',
        year: 1984,
        emoji: '🇩🇪',
        chinese: '德州巴黎',
        french: ''
      },
      {
        title: 'Gas Food Lodging',
        year: 1992,
        emoji: '🇺🇸',
        chinese: '旅客',
        french: ''
      },
      {
        title: 'Léon: The Professional',
        year: 1994,
        emoji: '🇫🇷',
        chinese: '这个杀手不太冷',
        french: ''
      },
      {
        title: 'Irréversible',
        year: 2002,
        emoji: '🇫🇷',
        chinese: '不可撤销',
        french: ''
      },
      {
        title: 'The Rock',
        year: 1996,
        emoji: '🇺🇸',
        chinese: '勇闯夺命岛',
        french: ''
      },
      {
        title: 'Daisies',
        year: 1966,
        emoji: '🇨🇿',
        chinese: '雏菊',
        french: ''
      },
      {
        title: 'Ahed\'s Knee',
        year: 2021,
        emoji: '🇮🇱',
        chinese: '阿赫德的膝盖',
        french: ''
      },
      {
        title: 'Chicago',
        year: 2002,
        emoji: '🇺🇸',
        chinese: '芝加哥',
        french: ''
      },
      {
        title: 'The Gleaners and I',
        year: 2000,
        emoji: '🇫🇷',
        chinese: '拾穗者',
        french: ''
      },
      {
        title: 'The Gleaners and I: Two Years Later',
        year: 2002,
        emoji: '🇫🇷',
        chinese: '拾穗者…两年后',
        french: ''
      },
      {
        title: 'Fish Tank',
        year: 2009,
        emoji: '🇬🇧',
        chinese: '鱼缸',
        french: ''
      },
      {
        title: 'Wings of Desire',
        year: 1987,
        emoji: '🇩🇪',
        chinese: '柏林苍穹下',
        french: ''
      },
      {
        title: 'Virgin Stripped Bare by Her Bachelors',
        year: 2000,
        emoji: '🇰🇷',
        chinese: '处女心经',
        french: ''
      },
      {
        title: 'Blow-up',
        year: 1966,
        emoji: '🇬🇧',
        chinese: '放大',
        french: ''
      },
      {
        title: 'Dogville',
        year: 2003,
        emoji: '🇩🇰',
        chinese: '狗镇',
        french: ''
      },
      {
        title: 'Rosemary\'s Baby',
        year: 1968,
        emoji: '🇺🇸',
        chinese: '罗斯玛丽的婴儿',
        french: ''
      },
      {
        title: 'The Conversation',
        year: 1974,
        emoji: '🇺🇸',
        chinese: '窃听大阴谋',
        french: ''
      },
      {
        title: 'Tokyo Story',
        year: 1953,
        emoji: '🇯🇵',
        chinese: '东京物语',
        french: ''
      },
      {
        title: 'An Autumn Afternoon',
        year: 1962,
        emoji: '🇯🇵',
        chinese: '秋刀鱼之味',
        french: ''
      },
      {
        title: 'A Story of Floating Weeds',
        year: 1934,
        emoji: '🇯🇵',
        chinese: '浮草物语',
        french: ''
      },
      {
        title: 'Casablanca',
        year: 1942,
        emoji: '🇺🇸',
        chinese: '卡萨布兰卡',
        french: ''
      },
      {
        title: 'The Beaches of Agnès',
        year: 2008,
        emoji: '🇫🇷',
        chinese: '阿涅斯的海滩',
        french: ''
      },
      {
        title: 'Documenteur',
        year: 1981,
        emoji: '🇫🇷',
        chinese: '纪录说谎家',
        french: ''
      },
      {
        title: 'One Sings, the Other Doesn\'t',
        year: 1977,
        emoji: '🇫🇷',
        chinese: '一个唱，一个不唱',
        french: ''
      },
      {
        title: 'Vagabond',
        year: 1985,
        emoji: '🇫🇷',
        chinese: '天涯沦落女',
        french: ''
      },
      {
        title: 'Jacquot de Nantes',
        year: 1991,
        emoji: '🇫🇷',
        chinese: '南特的雅克',
        french: ''
      },
      {
        title: 'Late Spring',
        year: 1949,
        emoji: '🇯🇵',
        chinese: '晩春',
        french: ''
      },
    ],
    myFavListIn2021: [
      {
        title: 'The House That Jack Built',
        year: 2018,
        emoji: '🇩🇰',
        chinese: '此房是我造',
        french: 'La maison que Jack a construite'
      },
      {
        title: 'Luzzu',
        year: 2021,
        emoji: '🇲🇹',
        chinese: '渔船',
        french: 'Luzzu'
      },
      {
        title: 'Hope',
        year: 2019,
        emoji: '🇳🇴',
        chinese: '绝境希望',
        french: 'Hope'
      },
      {
        title: 'Persian Lessons',
        year: 2020,
        emoji: '🇩🇪',
        chinese: '波斯语课',
        french: 'Persian Lessons'
      },
      {
        title: 'The Social Network',
        year: 2010,
        emoji: '🇺🇸',
        chinese: '社交网络',
        french: 'The Social Network'
      },
      {
        title: 'Citizen Kane',
        year: 1941,
        emoji: '🇺🇸',
        chinese: '公民凯恩',
        french: 'Citizen Kane'
      },
      {
        title: 'Juno',
        year: 2007,
        emoji: '🇺🇸',
        chinese: '朱诺',
        french: 'Juno'
      },
      {
        title: 'Cul-de-sac',
        year: 1966,
        emoji: '🇬🇧',
        chinese: '荒岛惊魂',
        french: 'Cul-de-sac'
      },
      {
        title: 'Dreaming an Island',
        year: 2021,
        emoji: '🇨🇭',
        chinese: 'Dreaming an Island',
        french: 'Dreaming an Island'
      },
      {
        title: 'Dirty Feathers',
        year: 2021,
        emoji: '🇺🇸',
        chinese: '肮脏的羽毛',
        french: 'Dirty Feathers'
      },
      {
        title: 'Minari',
        year: 2020,
        emoji: '🇺🇸',
        chinese: '米纳里',
        french: 'Minari'
      },
      {
        title: 'Transit',
        year: 2018,
        emoji: '🇩🇪',
        chinese: '过境',
        french: 'Transit'
      },
      {
        title: 'The Story of Looking',
        year: 2021,
        emoji: '🇬🇧',
        chinese: '视觉的故事',
        french: 'The Story of Looking'
      },
      {
        title: 'Chungking Express',
        year: 1994,
        emoji: '🇭🇰',
        chinese: '重庆森林',
        french: 'Chungking Express'
      },
      {
        title: 'Ordet',
        year: 1955,
        emoji: '🇩🇰',
        chinese: '词语',
        french: 'Ordet'
      },
      {
        title: 'Mad Max: Fury Road',
        year: 2015,
        emoji: '🇺🇸',
        chinese: '疯狂的麦克斯4：狂暴之路',
        french: 'Mad Max: Fury Road'
      },
      {
        title: 'La Haine',
        year: 1995,
        emoji: '🇫🇷',
        chinese: '怒火青春',
        french: 'La Haine'
      },
      {
        title: 'Pauline at the Beach',
        year: 1983,
        emoji: '🇫🇷',
        chinese: '沙滩上的宝莲',
        french: 'Pauline à la plage'
      },
      {
        title: 'Wanda',
        year: 1970,
        emoji: '🇺🇸',
        chinese: '旺达',
        french: 'Wanda'
      },
      {
        title: 'Spencer',
        year: 2021,
        emoji: '🇺🇸',
        chinese: '斯宾塞',
        french: 'Spencer'
      },
      {
        title: 'Drive My Car',
        year: 2021,
        emoji: '🇯🇵',
        chinese: '驾驶我的车',
        french: 'Drive My Car'
      }
    ],
    myFavListIn2020: [
      {
        title: 'Once Upon a Time... in Hollywood',
        year: 2019,
        emoji: '🇺🇸',
        chinese: '好莱坞往事'
      },
      {
        title: 'Les Misérables',
        year: 2019,
        emoji: '🇫🇷',
        chinese: '悲惨世界'
      },
      {
        title: 'Portrait of a Lady on Fire',
        year: 2019,
        emoji: '🇫🇷',
        chinese: '燃烧女子的肖像'
      },
      {
        title: 'The General',
        year: 1926,
        emoji: '🇺🇸',
        chinese: '将军号'
      },
      {
        title: 'Bike Thieves',
        year: 1948,
        emoji: '🇮🇹',
        chinese: '偷自行车的人'
      },
      {
        title: 'Beetlejuice',
        year: 1988,
        emoji: '🇺🇸',
        chinese: '阴间大法师'
      },
      {
        title: 'City of Gods',
        year: 2002,
        emoji: '🇧🇷',
        chinese: '上帝之城'
      },
      {
        title: 'Bille',
        year: 2018,
        emoji: '🇱🇻',
        chinese: '比莱'
      },
      {
        title: 'Talking About Trees',
        year: 2019,
        emoji: '🇸🇩',
        chinese: '当我们谈论树的时候'
      },
      {
        title: 'Asphalte',
        year: 2015,
        emoji: '🇫🇷',
        chinese: '心房客'
      },
      {
        title: 'Do The Right Thing',
        year: 1989,
        emoji: '🇺🇸',
        chinese: '为所应为'
      },
      {
        title: 'Amateur',
        year: 1994,
        emoji: '🇺🇸',
        chinese: '业余爱好者'
      },
      {
        title: 'His Girl Friday',
        year: 1940,
        emoji: '🇺🇸',
        chinese: '女友礼拜五'
      },
      {
        title: 'Love Meetings',
        year: 1964,
        emoji: '🇮🇹',
        chinese: '幽会百科'
      },
      {
        title: 'The Ground Beneath My Feet',
        year: 2019,
        emoji: '🇦🇹',
        chinese: '脚下的土地'
      },
      {
        title: 'City Dreamers',
        year: 2018,
        emoji: '🇨🇦',
        chinese: '城市梦想家'
      },
      {
        title: 'The Addams Family',
        year: 1991,
        emoji: '🇺🇸',
        chinese: '亚当斯一家'
      },
      {
        title: 'Cleo From 5 to 7',
        year: 1962,
        emoji: '🇫🇷',
        chinese: '克莱奥的五至七时'
      },
      {
        title: 'The Secret World of Arrietty',
        year: 2010,
        emoji: '🇯🇵',
        chinese: '借东西的小人阿莉埃蒂'
      }
    ]
  },
  portfolios: [
    {
      name: 'Data Visualization',
      slug: 'data-vis',
      coverImage: 'data-vis-cover.jpg',
      description: 'an interactive web app that converts raw data to graphs',
      tool: 'tool: Dash / Plotly in Python',
      codeURL: 'https://github.com/houqi2018/houqi-code-demo/tree/master/Data-Visualization-demo',
      images: [
        {
          source1: 'data-vis-bar-graph.jpg',
          caption1: 'Bar graph',
          source2: 'data-vis-dot-graph.jpg',
          caption2: 'Dot graph'
        },
        {
          source1: 'data-vis-box-graph.jpg',
          caption1: 'Box graph',
          source2: 'data-vis-violin-graph.jpg',
          caption2: 'Violin graph'
        },
      ]
    },
    {
      name: 'Museum Model',
      slug: 'museum-model',
      coverImage: 'museum-model-cover.jpg',
      description: 'a 3D virtual museum for music fans',
      tool: 'tool: SketchUp',
      codeURL: '',
      images: [
        {
          source1: 'museum-model-1.jpg',
          caption1: '',
          source2: 'museum-model-2.jpg',
          caption2: ''
        },
      ],
      videos: [
        {
          source: 'https://www.youtube-nocookie.com/embed/hyuJ6YI_8Co',
          caption: ''
        }
      ]
    },
  ]
};
